import React from "react";

export default function Tools() {
  return (
    <section style={{
      background: "#0f172a",
      border: "1px solid #1e293b",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 0 15px rgba(0, 255, 255, 0.08)",
      marginBottom: "2rem"
    }}>
      <h2 style={{ color: "#00f9ff", fontSize: "1.75rem", fontWeight: "bold" }}>Cybersecurity Tools</h2>
      <ul style={{ color: "#e2e8f0", marginTop: "1rem", lineHeight: "1.8" }}>
        <li><strong>Wireshark:</strong> Network packet analysis</li>
        <li><strong>Nmap:</strong> Port scanning and host discovery</li>
        <li><strong>Burp Suite:</strong> Web application vulnerability scanning</li>
        <li><strong>Metasploit:</strong> Penetration testing framework</li>
        <li><strong>Splunk:</strong> SIEM for log analysis and alerting</li>
      </ul>
    </section>
  );
}
